module.exports = __webpack_public_path__ + "img/circle-silver-logo-large.ff3eb8b4.png";